import type { HTMLAttributes } from "react";

interface CardProps extends HTMLAttributes<HTMLDivElement> {}

export function Card({ className = "", style, ...props }: CardProps) {
  return (
    <div
      className={`rounded-xl p-3 ${className}`}
      style={{
        backgroundColor: "var(--cn-horror-card-bg)",
        border: "1px solid var(--cn-horror-surface-border)",
        color: "var(--cn-horror-text)",
        ...style,
      }}
      {...props}
    />
  );
}
